import {isUserLoggedIn} from "@/auth/utils";

export default class LoggedInListener {
    listener;
    constructor(listener) {
        this.listener = listener;
    }

    listen() {
        if (isUserLoggedIn()) {
            this.listener.listen();
        }
    }

    stop() {
        this.listener.stop();
    }

    refresh() {
        this.listener.refresh();
    }
};
